module.exports = __webpack_public_path__ + "static/media/logo-blue.8fe72f40.png";